module.exports = __webpack_public_path__ + "img/win1.117b7a6f.png";